import React, {
    useState,
    useEffect,
    useContext,
    Fragment,
    useMemo,
    useCallback,
} from 'react';
import { useMediaQuery } from 'react-responsive';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Button from '../components/bronson/Button';
import Loading from '../components/bronson/Loading';
import IsUserLogged from '../components/IsUserLogged';
import ScrollToTop from '../components/ScrollToTop';
import Globals from '../Globals';
import Traductor from '../components/Traductor';

import Filters from '../components/ticketing/SearchTicket/Filters';
import CustomTable from '../components/ticketing/SearchTicket/List/CustomTable';
import ScrollToTopButton from '../components/ticketing/common/ScrollToTopButton';
import TicketingService from '../services/TicketingService';
import TagFilters from '../components/ticketing/SearchTicket/Filters/TagFilters';

import { withCookies } from 'react-cookie';
import { UserContext } from '../contexts/UserContext';

import TicketCard from '../components/ticketing/SearchTicket/TicketCard/index';
const SearchTicketPage = ({ history, cookies }) => {
    const { user } = useContext(UserContext);
    const [tickets, setTickets] = useState();
    const [selectedFiltersInitial] = useState([
        { IdUser: null },
        { userProfile: null },
        { Busqueda: '' },
        { dateStart: null },
        { dateEnd: null },
        { status: 0 },
        { Solictante: '' },
        { channelCode: '' },
        { NumeroPagina: 1 },
        { RegistrosPorPagina: 10 },
    ]);
    const [filters, setFilters] = useState(selectedFiltersInitial);
    const [selectedTagFilters, setTagSelectedFilters] = useState(
        { IdUser: null },
        { userProfile: null },
        { Busqueda: '' },
        { dateStart: null },
        { dateEnd: null },
        { status: '' },
        { Solictante: '' },
        { channelCode: '' }
    );
    const [ticket, setTicketDetail] = useState({
        IdTicket: '',
        Status: '',
        Plate: '',
        Date: '',
        OpFinan: '',
        Conces: '',
        Solicitante: '',
        Gestor: '',
        TelfGestor: '',
        EmailGestor: '',
        TipoTicket: '',
        DescrShort: '',
        DescrLong: '',
        Resolucion: '',
        DateEnd: '',
    });
    const [openDetail, setOpenDetail] = useState(false);
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [countSelectedFilters, setCountSelectedFilters] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastNumberTicket, setLastNumberTicket] = useState(0);
    const [MessageNotTicket, setMessageNotTicket] = useState('');
    const [loading, setLoading] = useState(true);
    const isMobile = useMediaQuery({
        minDeviceWidth: 960,
    });
    const t = useMemo(() => new Traductor(), []);
    const listHeaders = [
        '',
        t.getTraduction('TicketNumber'),
        t.getTraduction('Plate'),
        t.getTraduction('TicketCreationDate'),
        t.getTraduction('Status'),
        t.getTraduction('DescShort'),
        t.getTraduction('Solictante'),
        t.getTraduction('Concesionario'),
        t.getTraduction('OpFinanciera'),
    ];
    const [inputSelects, setInputSelects] = useState({
        selectConces: [],
        selectStates: [],
    });

    const getAllSelects = useCallback(() => {
        new TicketingService()
            .getSelects(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                user?.data?.Empleado?.Id
            )
            .then(response => {
                var newInputSelects = {
                    selectConces: response.body.SelectConces,
                    selectStates: response.body.SelectStates,
                };
                setInputSelects(newInputSelects);
            });
    }, [cookies, user?.data?.Empleado?.Id]);

    const getTickets = useCallback(
        async filters => {
            setLoading(true);
            setMessageNotTicket('');
            await new TicketingService()
                .getTickets(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    filters
                )
                .then(response => {
                    var newTickets = response.body;
                    setTickets(newTickets);
                    setLoading(false);
                    if (response) {
                        setMessageNotTicket(
                            t.getTraduction('WithoutTicket_title')
                        );
                        if (
                            newTickets.length > 0 &&
                            newTickets[0].RegistrosTotales
                        ) {
                            setLastNumberTicket(newTickets[0].RegistrosTotales);
                        } else {
                            setLastNumberTicket(newTickets.length);
                        }
                    }
                });
        },
        [cookies]
    );

    /*DETAILS*/

    const openDetailTicket = useCallback((isOpen, detail) => {
        setTicketDetail(detail);
        setOpenDetail(isOpen);
    }, []);

    const closeDetailTicket = useCallback(() => {
        if (openDetail) setOpenDetail(false);
    }, [openDetail]);

    const FormatStatus = useCallback(statusDescription => {
        let Max_lenght = 15;
        let Min_lenght = 8;
        let classPadding = 'c-tag  u-state_color_blue';
        if (statusDescription === 'Finalizado') {
            return (
                <span className="c-tag  u-state_ticket">
                    <span className="c-tag__label">{statusDescription}</span>
                </span>
            );
        } else {
            if (statusDescription.length > Max_lenght) {
                statusDescription = ShortenString(
                    statusDescription,
                    'Pendiente',
                    'Pdt.'
                );
                statusDescription = ShortenString(
                    statusDescription,
                    'Autorización',
                    'Aut.'
                );
                statusDescription = ShortenString(
                    statusDescription,
                    'Información',
                    'Info.'
                );
                classPadding = 'c-tag u-state_ticket_long  u-state_color_blue';
                if (statusDescription.indexOf('Pdt') !== -1)
                    classPadding =
                        'c-tag u-state_ticket_middle  u-state_color_blue';
                if (statusDescription.indexOf('Aut') !== -1)
                    classPadding =
                        'c-tag u-state_ticket_middle_long  u-state_color_blue';

                return (
                    <span className={classPadding}>
                        <span className="c-tag__label">
                            {statusDescription}
                        </span>
                    </span>
                );
            } else {
                classPadding = 'c-tag  u-state_ticket u-state_color_blue';
                if (statusDescription.length < Min_lenght)
                    classPadding =
                        'c-tag  u-state_ticket_short u-state_color_blue';
                return (
                    <span className={classPadding}>
                        <span className="c-tag__label">
                            {statusDescription}
                        </span>
                    </span>
                );
            }
        }
    }, []);

    const openTicketDetail = useCallback(() => {
        if (!openDetail) return null;
        return (
            <TicketCard
                card={ticket}
                closeTicket={closeDetailTicket}
                FormatStatus={FormatStatus}
                classExtra={isMobile ? 'c-detail_modal_ticket_wrapper' : ''}
            />
        );
    }, [FormatStatus, closeDetailTicket, openDetail, ticket]);

    /* TAGS */
    const tagsFiltersRefresh = useCallback(
        appliedSelectsTag => {
            let filtersTag = appliedSelectsTag;
            let newStatus;
            let newChannel;

            if (filtersTag['status'] !== undefined) {
                for (const state of inputSelects.selectStates) {
                    if (state.Value === filtersTag['status']) {
                        newStatus = state.Text;
                    }
                }

                filtersTag['status'] = newStatus;
            }
            if (filtersTag['channelCode'] !== undefined) {
                for (const state of inputSelects.selectConces) {
                    if (state.Value === filtersTag['channelCode']) {
                        newChannel = state.Text;
                    }
                }

                filtersTag['channelCode'] = newChannel;
            }
            setTagSelectedFilters(filtersTag);
        },
        [inputSelects.selectConces, inputSelects.selectStates]
    );

    const onFilter = useCallback(
        async (data, bag) => {
            data.userProfile = user.data.Profile;
            data.IdUser = user?.data?.Empleado?.Id;
            data.NumeroPagina = currentPage;
            data.RegistrosPorPagina = 10;
            const appliedFilters = Object.fromEntries(
                Object.entries(data).filter(([key, value]) => !!value)
            );
            const appliedSelectsTag = Object.fromEntries(
                Object.entries(data).filter(([key, value]) => !!value)
            );
            setFilters(appliedFilters);
            tagsFiltersRefresh(appliedSelectsTag);
            await getTickets(appliedFilters);
            openTicketDetail(false);
        },
        [
            cookies,
            currentPage,
            getTickets,
            openTicketDetail,
            tagsFiltersRefresh,
            user.data.Profile,
            user?.data?.Empleado?.Id,
        ]
    );

    /*DETAILS*/
    const ResetValues = useCallback(setField => {
        setField('Busqueda', '');
        setField('dateStart', '');
        setField('dateEnd', '');
        setField('status', 0);
        setField('Solicitante', '');
        setField('channelCode', '');
        setTagSelectedFilters(selectedFiltersInitial);
    }, []);

    const refreshFilters = useCallback(tagsShowing => {
        setCountSelectedFilters(tagsShowing);
        setCurrentPage(1);
    }, []);

    const resetFilters = useCallback(
        setField => {
            refreshFilters(0);
            ResetValues(setField);
        },
        [ResetValues, refreshFilters]
    );

    const printTagFilters = setFieldValue => {
        return (
            <div id="TagFiltersList" className="o-layout__item u-8/12 u-1/1@m">
                <ul className="c-tag-list">
                    <TagFilters
                        pSelectedFilters={selectedTagFilters}
                        resetFilters={resetFilters}
                        refreshSelectedFilters={refreshFilters}
                        setField={setFieldValue}
                        countFilters={setCountSelectedFilters}
                        setFilters={setFilters}
                        setTagSelectedFilters={setTagSelectedFilters}
                    />
                </ul>
            </div>
        );
    };
    /* TAGS */
    useEffect(() => {
        onFilter(filters);
    }, [currentPage]);

    /*FILTERS*/
    const printAlertOrFilterButtons = () => {
        if (isMobile) return null;

        let optionsAdvancedFiltersMobile = {
            text:
                t.getTraduction('Filters') +
                ' ' +
                (countSelectedFilters > 0
                    ? '(' + countSelectedFilters + ')'
                    : ''),
            class: 'c-btn--full',
        };

        return (
            <Button
                options={optionsAdvancedFiltersMobile}
                onClick={() => openAdvancedFilterModal()}
            ></Button>
        );
    };

    const openAdvancedFilterModal = () => {
        setOpenFilterModal(currentState => !currentState);
    };

    const closeFilterModal = useCallback(() => {
        if (openFilterModal) setOpenFilterModal(false);
    }, [openFilterModal]);
    /*FILTERS*/

    /* FORMAT  CUSTOMTABLE+DETAIL */

    const ShortenString = (iniString, word, abrevia) => {
        let rString = iniString;
        if (iniString.indexOf(word) !== -1) {
            rString = '';
            rString += iniString.split(word).map((p, i) => {
                let resultEstado;
                if (i === 0) {
                    resultEstado = abrevia;
                } else {
                    resultEstado = p;
                }
                return resultEstado;
            });
            rString = rString.replace(', ', ' ');
        }
        return rString;
    };

    /* FORMAT  CUSTOMTABLE+DETAIL*/

    const PrintTicketsAmount = () => {
        let TicketsAmount = 0;
        if (tickets !== undefined && tickets !== null && tickets.length !== 0) {
            TicketsAmount = tickets[0].RegistrosTotales;
        }
        if (TicketsAmount !== 0) {
            return (
                <h3 className="u-mb" style={{ fontWeight: 'normal' }}>
                    <strong> {TicketsAmount} </strong>{' '}
                    {' ' + t.getTraduction('TicketHistory')}
                </h3>
            );
        } else {
            return (
                <h3 className="u-mb" style={{ fontWeight: 'normal' }}>
                    {MessageNotTicket}{' '}
                </h3>
            );
        }
    };
    const printButtonCreateTicket = () => {
        return (
            <div className="o-layout__item u-3/12 u-1/2@m">
                <button
                    onClick={onClickGoToCreateTicket}
                    className={
                        isMobile
                            ? 'c-btn c_button_create_ticket'
                            : 'c-btn  c-btn--full'
                    }
                >
                    {t.getTraduction('CreateTicket')}
                </button>
            </div>
        );
    };
    const onClickGoToCreateTicket = useCallback(() => {
        const route = Globals.APPLICATION_PATH.CREATE_TICKET;
        if (history.location.pathname !== route) {
            history.push(route);
        }
    }, [history]);

    const filterClasses = useMemo(
        () =>
            openFilterModal && isMobile
                ? ''
                : 'o-layout__item u-1/6 u-3/12@l u-hide@m u-ticket_max_width',
        [isMobile, openFilterModal]
    );

    return (
        <Fragment>
            <section className="o-content-section u-pt-small u-rema-full-height">
                <ScrollToTop />
                <div className="o-page-wrap o-page-wrap--xsmall">
                    <Formik
                        initialValues={{
                            IdUser: '',
                            userProfile: user.data.Profile || '',
                            Busqueda: '',
                            dateStart: '',
                            dateEnd: '',
                            channelCode: '',
                            status: '',
                            Solicitante: '',
                            NumeroPagina: 1,
                            RegistrosPorPagina: 10,
                        }}
                        onSubmit={onFilter}
                        validationSchema={Yup.object().shape({
                            Busqueda: Yup.string(),
                            dateStart: Yup.string(),
                            dateEnd: Yup.string(),
                            channelCode: Yup.string(),
                            status: Yup.number(),
                            Solicitante: Yup.string(),
                        })}
                    >
                        {({ values, handleSubmit, setFieldValue }) => (
                            <>
                                <fieldset className="o-fieldset">
                                    <div
                                        className={
                                            isMobile
                                                ? 'o-layout__item o-layout_link_return_ticket u-9/12 u-1/2@m'
                                                : ' o-layout_link_return_ticket u-9/12'
                                        }
                                    >
                                        <h1>
                                            {t.getTraduction('TicketManage')}
                                        </h1>
                                    </div>
                                    {isMobile
                                        ? printButtonCreateTicket()
                                        : null}

                                    <span className="c-form-heading__title-text">
                                        {PrintTicketsAmount()}
                                    </span>
                                </fieldset>
                                <div className="o-layout u-mb u-mt">
                                    {isMobile
                                        ? printTagFilters(setFieldValue)
                                        : null}
                                    <div className="o-layout__item u-1/12 u-1/2@m">
                                        {printAlertOrFilterButtons()}
                                    </div>
                                    {!isMobile
                                        ? printButtonCreateTicket()
                                        : null}
                                    {!isMobile
                                        ? printTagFilters(setFieldValue)
                                        : null}
                                </div>
                                {
                                    //printPrincipalFilters(values, handleSubmit, setFieldValue)
                                }
                                {isMobile || openFilterModal ? (
                                    <Filters
                                        values={values}
                                        onChange={setFieldValue}
                                        onFilter={handleSubmit}
                                        classFilters={filterClasses}
                                        inputSelects={inputSelects}
                                        getAllSelects={getAllSelects}
                                        setPage={setCurrentPage}
                                        currentPage={currentPage}
                                        setFilters={setFilters}
                                    />
                                ) : null}
                            </>
                        )}
                    </Formik>
                    <div className="o-layout__item u-5/6 u-9/12@l u-1/1@m">
                        <div className=".c-table">
                            <CustomTable
                                list={tickets}
                                openDetailTicket={openDetailTicket}
                                valueChanging={tickets}
                                headers={listHeaders}
                                FormatStatus={FormatStatus}
                                itemKey={'Id'}
                                parentCurrentPage={currentPage}
                                lastNumberTicket={lastNumberTicket}
                                setCurrentPage={setCurrentPage}
                                isLoading={loading}
                                isMobile={isMobile}
                            />
                        </div>
                    </div>
                </div>
                {/* <ScrollToTopButton /> */}
            </section>
            {openTicketDetail()}
        </Fragment>
    );
};

export default withCookies(SearchTicketPage);
